import React from "react"
import styled, { css } from "styled-components"

const CheckBox = ({ checked, ...props }) => {
  return (
    <CheckBoxContainer>
      <HiddenCheckBox checked={checked} {...props} />

      <StyledCheckBox checked={checked} circle={props.circle}>
        <CheckIcon viewBox="0 0 24 24">
          <polyline points="20 5 10 19 3 12" />
        </CheckIcon>
      </StyledCheckBox>
    </CheckBoxContainer>
  )
}

const CheckBoxContainer = styled.div`
  display: inline-block;
  margin-right: calc(100vw * (12 / 375));
  vertical-align: top;
`

const HiddenCheckBox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: calc(100vw * (1 / 375));
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: calc(100vw * (1 / 375));
`

const CheckIcon = styled.svg`
  fill: none;
  stroke: #fff;
  stroke-width: 2px;
`

const stlyedCircle = css`
  ${(props) =>
    props.circle &&
    css`
      border-radius: 100%;
    `}
`
const StyledCheckBox = styled.div`
  display: inline-block;
  width: calc(100vw * (18 / 375));
  height: calc(100vw * (18 / 375));
  border: ${(props) => (props.checked ? "1px solid #000" : "1px solid #7f7f7f")};
  background: ${(props) => (props.checked ? "#000" : "#fff")};
  border-radius: calc(100vw * (3 / 375));
  ${stlyedCircle}
  ${CheckIcon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`

export default CheckBox
